import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unixTimestampToDate'
})
export class UnixTimestampToDatePipe implements PipeTransform {
  transform(value: number | null | undefined, format: string = 'short'): string {
    if (!value) {
      return '';
    }

    const date = new Date(value * 1000); // Convert Unix timestamp to milliseconds
    const options: Intl.DateTimeFormatOptions =
      format === 'short'
        ? { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }
        : { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  }

}
